import { readLocal, writeLocal } from './browser'
import { uuidv7 } from './uuidv7'

/*
  A stable id for this browser, made once and remembered. POST /sync/commands requires one
  (RequestValidators: DeviceId not empty) and the audit log records it beside the user: the
  bearer token says who, this says from where. NOT a secret and NOT an identity. A browser
  that cannot remember it gets a new one per page load, which only makes the audit coarser.
*/
const KEY = 'deviceId'
let cached: string | null = null

export function getDeviceId(): string {
  if (cached) return cached
  const existing = readLocal<string>(KEY)
  cached = existing ?? uuidv7()
  if (!existing) writeLocal(KEY, cached)
  return cached
}

/** Test seam. */
export function resetDeviceIdForTests(): void {
  cached = null
}
